import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";
import { httpGet, httpPost, httpPut, httpDelete } from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getUser(userID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");

    let apiUrl = `${
      this.apiEndpoint
    }/api/sdk/v2/${clinicID}/user/${Crypto.encrypt(userID, CryptoKey)}`;
    return httpGet(apiUrl);
  }

  getBulkUser(userIDs) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/user/bulk/read`;
    return httpPost(apiUrl, { ids: userIDs });
  }

  createUser(userData) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/user`;
    return httpPost(apiUrl, userData);
  }

  modifyUser(userID, userData) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/user/${Crypto.encrypt(userID, CryptoKey)}`;
    return httpPut(apiUrl, userData);
  }

  deleteUser(userID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/user/${Crypto.encrypt(userID, CryptoKey)}`;
    return httpDelete(apiUrl);
  }

  getUserList(options) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/user/getList`;
    return httpPost(apiUrl, options);
  }

  searchUser(options) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/user/search`;
    return httpPost(apiUrl, options);
  }

  getUserPage(currentPage) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/user/getListPage`;
    return httpPost(apiUrl, currentPage);
  }

  deleteUserLine(userID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/user/line/${Crypto.encrypt(userID, CryptoKey)}`;
    return httpDelete(apiUrl);
  }

  sendLineMessage(contents) {
    // console.log("sendLineMessage", contents);
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/user/line/${Crypto.encrypt(contents.userID, CryptoKey)}`;
    return httpPost(apiUrl, contents);
  }

  passUserMessage(userID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/user/line/${Crypto.encrypt(userID, CryptoKey)}`;
    return httpPut(apiUrl);
  }

  touchUser(userID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/user/${Crypto.encrypt(userID, CryptoKey)}/touch`;
    return httpPost(apiUrl);
  }
}
